import React from "react";
import "./ContentIdeatorKavya.css";
import { Box } from "@mui/material";

export default function ContentIdeatorKavya() {
    return (
        <Box
            sx={{
                position: "relative",
                m: -3,
                height: "100dvh",
                overflow: "hidden",
            }}
        >
            <df-messenger
                location="us-central1"
                project-id="pro-park-450504-e1"
                agent-id="1a1b36f0-d43f-4dc3-bf79-12d7229778dc"
                language-code="en"
                max-query-length="-1"
            >
                <df-messenger-chat
                    chat-title="Kavya Mehra"
                    allow-fullscreen="always"
                ></df-messenger-chat>
            </df-messenger>
        </Box>
    );
}
